export default "__VITE_ASSET__BRy6_AnB__"